import IconFlame from '@tabler/icons-react/dist/esm/icons/IconFlame.mjs';
import IconFlameOff from '@tabler/icons-react/dist/esm/icons/IconFlameOff.mjs';
import IconFileImport from '@tabler/icons-react/dist/esm/icons/IconFileImport.mjs';
import IconFileBroken from '@tabler/icons-react/dist/esm/icons/IconFileBroken.mjs';
import IconFileAlert from '@tabler/icons-react/dist/esm/icons/IconFileAlert.mjs';
import IconBinaryTree from '@tabler/icons-react/dist/esm/icons/IconBinaryTree.mjs';

export const EVENT_ICONS = {
  firing: IconFlame,
  resolved: IconFlameOff,
  ci_import_started: IconFileImport,
  ci_import_ok: IconFileImport,
  ci_import: IconFileImport,
  ci_import_warn: IconFileAlert,
  ci_import_error: IconFileAlert,
  ci_import_statistic: IconFileBroken,
  enrichment_started: IconBinaryTree,
  enrichment_ok: IconBinaryTree,
  enrichment_warn: IconBinaryTree,
  enrichment_error: IconBinaryTree,
  enrichment: IconBinaryTree,
};